module.exports = __webpack_public_path__ + "static/media/green-sectors.376d08d4.svg";